/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

import type { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents a monetary value in cents of USD. Transported as an int (e.g., 1000 for $10.00). */
  Cents: { input: import("@betterment/core").Money; output: import("@betterment/core").Money; }
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string.
   */
  Date: { input: string; output: Date; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC and any UTC offset other than 0 will be rejected.
   */
  DateTime: { input: Date; output: Date; }
  /** Represents HTML rendered content. Transported as a String. E.g.: "<b>Hello</b> world". */
  HTML: { input: string; output: DocumentFragment; }
  /** Represents a percent value. Transported as a Float. Ex: 50 represents 50%, and 0.5 represents 0.5%. */
  Percent: { input: number; output: number; }
};

/** The authorization tier of a plan manager for a given employer */
export const AuthorizationTier = {
  /** User and settings management */
  Administrator: 'ADMINISTRATOR',
  /** Commenting and dashboard access */
  Staff: 'STAFF',
  /** Dashboard access */
  ViewOnly: 'VIEW_ONLY'
} as const;

export type AuthorizationTier = typeof AuthorizationTier[keyof typeof AuthorizationTier];
/** A report for a 401(k) plan or other workplace benefit */
export type BenefitReport = ReportInterface & {
  __typename: 'BenefitReport';
  /** The format of the report file (PDF, CSV, or ZIP) */
  contentType: BenefitReportContentType;
  /** The timestamp when the report was created */
  createdAt: Scalars['DateTime']['output'];
  /** The employer associated with the report */
  employer: Employer;
  /** The end date of the reporting period */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The filename of the report */
  filename: Scalars['String']['output'];
  /** The unique identifier for the report */
  id: Scalars['ID']['output'];
  /** The package this report belongs to, if any */
  investmentActivityPackage?: Maybe<InvestmentActivityPackage>;
  /** The name of the report */
  name: Scalars['String']['output'];
  /** The start date of the reporting period */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the report (PENDING or COMPLETE) */
  status: BenefitReportStatus;
};

/** The content type of a 401(k) report file */
export const BenefitReportContentType = {
  /** A csv file */
  Csv: 'CSV',
  /** A PDF file */
  Pdf: 'PDF',
  /** A ZIP file */
  Zip: 'ZIP'
} as const;

export type BenefitReportContentType = typeof BenefitReportContentType[keyof typeof BenefitReportContentType];
/** Options available for creating a 401(k) plan or other B@W benefit report */
export type BenefitReportCreationOption = {
  __typename: 'BenefitReportCreationOption';
  /** An additional explanatory blurb to help the user interpret the report. Supports a subset of html */
  additionalGuidance?: Maybe<Scalars['HTML']['output']>;
  /** An identifier referencing a specific report that can be used as a path param */
  altIdentifier: Scalars['String']['output'];
  /** The columns included in the report */
  columns: Array<Scalars['String']['output']>;
  /** The description of the report */
  description: Scalars['String']['output'];
  /** A unique identifier for the report creation option */
  id: Scalars['ID']['output'];
  /** The inputs required to create the report */
  inputs: Array<BenefitReportInputOption>;
  /** Whether the report is commonly run */
  isCommon: Scalars['Boolean']['output'];
  /** The name of the report creation option */
  name: Scalars['String']['output'];
  /** The type of the report creation option */
  type: Scalars['String']['output'];
};

/** Input options for creating a 401(k) plan report */
export type BenefitReportInputOption = {
  __typename: 'BenefitReportInputOption';
  /** The attribute name of the input option */
  attribute: Scalars['String']['output'];
  /** The default value of the input. Represented as a string, for easy integration with form inputs */
  default?: Maybe<Scalars['String']['output']>;
  /** The label of the input option */
  label: Scalars['String']['output'];
  /** The type of the input option */
  type: BenefitReportInputOptionType;
};

/** The type of input data we're expecting from the user user to run a report */
export const BenefitReportInputOptionType = {
  /** A JSON boolean (true/false) */
  Boolean: 'BOOLEAN',
  /** A iso8601 date string (ie 2025-01-01) */
  Date: 'DATE',
  /** A four digit year string (ie 2023) */
  Year: 'YEAR'
} as const;

export type BenefitReportInputOptionType = typeof BenefitReportInputOptionType[keyof typeof BenefitReportInputOptionType];
/** The status of a 401(k) report */
export const BenefitReportStatus = {
  /** Complete */
  Complete: 'COMPLETE',
  /** Pending */
  Pending: 'PENDING'
} as const;

export type BenefitReportStatus = typeof BenefitReportStatus[keyof typeof BenefitReportStatus];
/** Autogenerated input type of CapturePackageSignatureMutation */
export type CapturePackageSignatureMutationInput = {
  /** The ID of the record tracking the signable package. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CapturePackageSignatureMutation. */
export type CapturePackageSignatureMutationPayload = {
  __typename: 'CapturePackageSignatureMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CapturePackageSignatureMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CapturePackageSignatureMutation execution as type SignablePackage. */
  result?: Maybe<SignablePackage>;
};

/**
 * Input structure for an argument for a benefit report, not every field applies to
 * every report, which is way they're all not required. We rely on runtime
 * validation to ensure the right inputs are provided
 */
export type CreateBenefitReportInput = {
  /** Filters to the only active participants, only applies to the deferral history report */
  activeParticipantsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** End date for data filtering for reports that are time limited */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filters to the latest records, only applies to the deferral history report */
  latestOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show the full ssn on reports that include it */
  showSsn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start date for data filtering for reports for report that are time limited */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Year for annual reports */
  year?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateBenefitReportMutation */
export type CreateBenefitReportMutationInput = {
  /** The id of the employer this report is for */
  employerId: Scalars['ID']['input'];
  /** The user provided inputs into report generation */
  reportInput: CreateBenefitReportInput;
  /** The type/name of the report to generate */
  type: Scalars['String']['input'];
};

/** Autogenerated return type of CreateBenefitReportMutation. */
export type CreateBenefitReportMutationPayload = {
  __typename: 'CreateBenefitReportMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateBenefitReportMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateBenefitReportMutation execution as type BenefitReport. */
  result?: Maybe<BenefitReport>;
};

/** A zip file containing reports specific to a 401(k) plan deconversion */
export type DeconversionReport = ReportInterface & {
  __typename: 'DeconversionReport';
  /** The format of the report file (PDF, CSV, or ZIP) */
  contentType: BenefitReportContentType;
  /** The timestamp when the report was created */
  createdAt: Scalars['DateTime']['output'];
  /** The employer associated with the report */
  employer: Employer;
  /** The filename of the report */
  filename: Scalars['String']['output'];
  /** The unique identifier for the report */
  id: Scalars['ID']['output'];
  /** Date on which funds will be sent from Betterment to the new 401(k) provider */
  liquidationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the report */
  name: Scalars['String']['output'];
  /** The current status of the report (PENDING or COMPLETE) */
  status: BenefitReportStatus;
};

/** A recoverable error that can be displaying to the User. */
export type DisplayableError = {
  __typename: 'DisplayableError';
  /** A human-readable error message to display to the user explaining the error and remediating actions. */
  message: Scalars['String']['output'];
  /** The path, the Operation entity or Input value that is the source of the error. */
  path: Array<Scalars['String']['output']>;
};

/** DocuSign-related attributes required for signing the DocuSign envelope in-app. */
export type DocusignSignature = {
  __typename: 'DocusignSignature';
  /** The DocuSign Client ID */
  clientId: Scalars['String']['output'];
  /** The DocuSign signature URL */
  signatureUrl: Scalars['String']['output'];
};

/** An email preference setting for the plan manager for a given customer */
export type EmailPreference = {
  __typename: 'EmailPreference';
  /** The category of emails controlled by this preference */
  category: EmailPreferenceCategory;
  /** The enum value for the email preference */
  id: Scalars['ID']['output'];
  /** Whether or not the plan sponsor has opted into receiving this category of notification */
  isEnabled: Scalars['Boolean']['output'];
  /** Human readable description of the kinds of notifications controlled by this preference */
  label: Scalars['String']['output'];
};

/** A discrete notification preference the plan sponsor can enable or disable, which controls some subset of the emails they get */
export const EmailPreferenceCategory = {
  /** Controls whether the plan sponsor gets emails when participants change their deferral settings */
  ReceiveDeferralSettingChangeEmails: 'RECEIVE_DEFERRAL_SETTING_CHANGE_EMAILS',
  /** Controls whether the plan sponsor receives emails when participants request loans and distributions */
  ReceiveDistributionAndLoanEmails: 'RECEIVE_DISTRIBUTION_AND_LOAN_EMAILS',
  /** Controls whether the plan sponsor gets emails when new payrolls are created */
  ReceivePayrollEmails: 'RECEIVE_PAYROLL_EMAILS',
  /** Controls whether the plan sponsor receives misc emails about general 401k plan administration */
  ReceivePlanAdministrationEmails: 'RECEIVE_PLAN_ADMINISTRATION_EMAILS'
} as const;

export type EmailPreferenceCategory = typeof EmailPreferenceCategory[keyof typeof EmailPreferenceCategory];
/** The employment relationship of an individual to an employer */
export type Employee = {
  __typename: 'Employee';
  /** The unique identifier of the employee */
  id: Scalars['ID']['output'];
  /** The employee's Roth 401(k) account */
  roth401kLegalAccount?: Maybe<LegalAccount>;
  /** The employee's traditional 401(k) account */
  traditional401kLegalAccount: LegalAccount;
};

/** Represents an organization that has an account in the B@W system */
export type Employer = {
  __typename: 'Employer';
  /**
   * A list of what kinds of notifications and emails the plan manager can receive
   * for a given customer, and which ones the plan manager has opted into
   */
  emailPreferences: Array<EmailPreference>;
  /** The details for a single employer given their id */
  employee: Employee;
  /** The 529 education savings benefit associated with this employer */
  fiveTwoNineBenefit?: Maybe<FiveTwoNineBenefit>;
  /** The unique identifier to the employer */
  id: Scalars['ID']['output'];
  /** The name of the employer organization */
  name: Scalars['String']['output'];
  /** The onboarding associated with this employer */
  onboarding?: Maybe<Onboarding>;
  /** The 401(k) plan associated with this employer */
  plan?: Maybe<Plan>;
  /** A list of possible reports that current user can run for this employer */
  reportCreationOptions: Array<BenefitReportCreationOption>;
  /** A list of plan years that may be used to generate a report */
  reportableYears: Array<Scalars['String']['output']>;
  /** A list of reports the employer has access to */
  reports: Array<BenefitReport | DeconversionReport | InvestmentActivityPackage>;
  /** Support information for this employer's plan, including an ordered list of contacts */
  support: EmployerSupport;
  /** Represents a list of tasks and their count the employer needs to complete */
  tasks: TaskCollection;
};


/** Represents an organization that has an account in the B@W system */
export type EmployerEmployeeArgs = {
  id: Scalars['ID']['input'];
};

/** Support information for an employer's 401(k) plan */
export type EmployerSupport = {
  __typename: 'EmployerSupport';
  /**
   * Ordered list of support contacts for this employer's plan. Always contains at
   * least the employee support entry. Other contacts are included based on the
   * employer's plan setup and onboarding state.
   */
  contacts: Array<SupportContact>;
};

/** Represents a 529 education savings benefit */
export type FiveTwoNineBenefit = {
  __typename: 'FiveTwoNineBenefit';
  /** The current status of the 529 benefit */
  status: FiveTwoNineBenefitStatus;
};

/** The status of a 529 education savings benefit */
export const FiveTwoNineBenefitStatus = {
  /** 529 benefit is active */
  Active: 'ACTIVE',
  /** 529 benefit has been deactivated */
  Deactivated: 'DEACTIVATED',
  /** 529 benefit is pending activation */
  Pending: 'PENDING'
} as const;

export type FiveTwoNineBenefitStatus = typeof FiveTwoNineBenefitStatus[keyof typeof FiveTwoNineBenefitStatus];
/** Autogenerated input type of ForwardPackageSignatureMutation */
export type ForwardPackageSignatureMutationInput = {
  /** The new signer's full name. */
  email: Scalars['String']['input'];
  /** The new signer's email address. */
  name: Scalars['String']['input'];
  /** The ID of the record tracking the signable package. */
  signablePackageId: Scalars['ID']['input'];
};

/** Autogenerated return type of ForwardPackageSignatureMutation. */
export type ForwardPackageSignatureMutationPayload = {
  __typename: 'ForwardPackageSignatureMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ForwardPackageSignatureMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ForwardPackageSignatureMutation execution as type SignablePackage. */
  result?: Maybe<SignablePackage>;
};

/** A zip file containing investment activity reports (security activity, cash activity, and participant ledger) */
export type InvestmentActivityPackage = ReportInterface & {
  __typename: 'InvestmentActivityPackage';
  /** The format of the report file (PDF, CSV, or ZIP) */
  contentType: BenefitReportContentType;
  /** The timestamp when the report was created */
  createdAt: Scalars['DateTime']['output'];
  /** The employer associated with the report */
  employer: Employer;
  /** End date of the reporting period */
  endDate: Scalars['DateTime']['output'];
  /** The filename of the report */
  filename: Scalars['String']['output'];
  /** The unique identifier for the report */
  id: Scalars['ID']['output'];
  /** The level of the package: 'plan' or 'participant' */
  level: Scalars['String']['output'];
  /** The name of the report */
  name: Scalars['String']['output'];
  /** Start date of the reporting period */
  startDate: Scalars['DateTime']['output'];
  /** The current status of the report (PENDING or COMPLETE) */
  status: BenefitReportStatus;
};

/** An employee's traditional or Roth 401(k) account */
export type LegalAccount = {
  __typename: 'LegalAccount';
  /** The account's current payroll contribution rate for the employee's base compensation */
  baseContributionRate: PayrollContributionRate;
  /** The account's current payroll contribution rate for the employee's bonus compensation */
  bonusContributionRate?: Maybe<PayrollContributionRate>;
  /** The ID for the legal account */
  id: Scalars['ID']['output'];
};

/** Used to update the contribution rates for an employee's 401(k) account */
export type LegalAccountPayrollContributionRatesInput = {
  /** The contribution rate applied to base compensation */
  baseRate: PayrollContributionRateInput;
  /**
   * The contribution rate applied to bonus compensation. This rate can only be set
   * for employees that have bonus payroll contribution rates
   */
  bonusRate?: InputMaybe<PayrollContributionRateInput>;
  /** The ID of the legal account */
  legalAccountId: Scalars['ID']['input'];
};

/** The entrypoint for all b4b schema mutations */
export type Mutation = {
  __typename: 'Mutation';
  /** Capture signature of a signable package. */
  capturePackageSignature: CapturePackageSignatureMutationPayload;
  /** Asynchronously generates a new report based on the provided inputs */
  createBenefitReport: CreateBenefitReportMutationPayload;
  /** Forward signature of a signable package. */
  forwardPackageSignature: ForwardPackageSignatureMutationPayload;
  /** Reclaim a package that was forwarded to an external recipient for in-app signing. */
  reclaimPackageSignature: ReclaimPackageSignatureMutationPayload;
  /** Updates an employee's 401(k) contribution rates */
  updateEmployeeContributionRates: UpdateEmployeeContributionRatesMutationPayload;
};


/** The entrypoint for all b4b schema mutations */
export type MutationCapturePackageSignatureArgs = {
  input: CapturePackageSignatureMutationInput;
};


/** The entrypoint for all b4b schema mutations */
export type MutationCreateBenefitReportArgs = {
  input: CreateBenefitReportMutationInput;
};


/** The entrypoint for all b4b schema mutations */
export type MutationForwardPackageSignatureArgs = {
  input: ForwardPackageSignatureMutationInput;
};


/** The entrypoint for all b4b schema mutations */
export type MutationReclaimPackageSignatureArgs = {
  input: ReclaimPackageSignatureMutationInput;
};


/** The entrypoint for all b4b schema mutations */
export type MutationUpdateEmployeeContributionRatesArgs = {
  input: UpdateEmployeeContributionRatesMutationInput;
};

/** Represents an employer onboarding process */
export type Onboarding = {
  __typename: 'Onboarding';
  /** The current status of the onboarding */
  status: OnboardingStatus;
};

/** The status of an employer onboarding */
export const OnboardingStatus = {
  /** Onboarding has been canceled */
  Canceled: 'CANCELED',
  /** Onboarding is complete */
  Complete: 'COMPLETE',
  /** Onboarding is being created */
  Created: 'CREATED',
  /** Onboarding is on hold */
  OnHold: 'ON_HOLD'
} as const;

export type OnboardingStatus = typeof OnboardingStatus[keyof typeof OnboardingStatus];
/** The amount value for a payroll contribution */
export type PayrollContributionAmount = {
  __typename: 'PayrollContributionAmount';
  /** The value as an amount in cents */
  amount: Scalars['Cents']['output'];
};

/** The percent value for a payroll contribution */
export type PayrollContributionPercent = {
  __typename: 'PayrollContributionPercent';
  /** The value as a percent */
  percent: Scalars['Percent']['output'];
};

/** The rate for a payroll contribution, as either a currency amount or a percentage */
export type PayrollContributionRate = PayrollContributionAmount | PayrollContributionPercent;

/** The input rate for a payroll contribution, as either a currency amount or a percentage */
export type PayrollContributionRateInput =
  /** The value as an amount in cents */
  { amount: Scalars['Cents']['input']; percent?: never; }
  |  /** The value as a percent */
  { amount?: never; percent: Scalars['Percent']['input']; };

/** Represents the personal information of a plan manager */
export type PersonalProfile = {
  __typename: 'PersonalProfile';
  /** The authorization tier of the plan manager for the given employer */
  authorizationTier: Scalars['String']['output'];
  /** The email address of the plan manager */
  email: Scalars['String']['output'];
  /** The first name of the plan manager */
  firstName: Scalars['String']['output'];
  /**
   * Whether the plan manager is an advisor. Advisors have access to additional
   * features and management capabilities across multiple employer plans.
   */
  isAdvisor: Scalars['Boolean']['output'];
  /** The job title of the plan manager */
  jobTitle: Scalars['String']['output'];
  /** The last name of the plan manager */
  lastName: Scalars['String']['output'];
  /** The middle initial of the plan manager */
  middleInitial?: Maybe<Scalars['String']['output']>;
  /** The work phone number of the plan manager; e.g. (480)-222-3344 */
  workPhoneNumber: Scalars['String']['output'];
};

/** Represents a 401(k) plan */
export type Plan = {
  __typename: 'Plan';
  /** The current status of the plan */
  status: PlanStatus;
};

/** The status of a 401(k) plan */
export const PlanStatus = {
  /** Plan has been abandoned */
  Abandoned: 'ABANDONED',
  /** Plan is active and operational */
  Active: 'ACTIVE',
  /** Plan has been transferred to another provider */
  Deconverted: 'DECONVERTED',
  /** Plan is being transferred to another provider */
  Deconverting: 'DECONVERTING',
  /** Plan was never funded */
  NeverFunded: 'NEVER_FUNDED',
  /** Plan is being set up */
  Onboarding: 'ONBOARDING',
  /** Plan has been terminated */
  Terminated: 'TERMINATED',
  /** Plan is being terminated */
  Terminating: 'TERMINATING'
} as const;

export type PlanStatus = typeof PlanStatus[keyof typeof PlanStatus];
/** The entrypoint for all b4b schema queries */
export type Query = {
  __typename: 'Query';
  /** The details for a single employer by id */
  employer: Employer;
  /** The list of all employers the plan manager has access to */
  employers: Array<Employer>;
  /** The personal profile of the current plan manager */
  personalProfile: PersonalProfile;
  /** The details for a signable package by id */
  signablePackage: SignablePackage;
};


/** The entrypoint for all b4b schema queries */
export type QueryEmployerArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all b4b schema queries */
export type QueryPersonalProfileArgs = {
  employerId: Scalars['ID']['input'];
};


/** The entrypoint for all b4b schema queries */
export type QuerySignablePackageArgs = {
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of ReclaimPackageSignatureMutation */
export type ReclaimPackageSignatureMutationInput = {
  /** The ID of the signable package. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ReclaimPackageSignatureMutation. */
export type ReclaimPackageSignatureMutationPayload = {
  __typename: 'ReclaimPackageSignatureMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ReclaimPackageSignatureMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ReclaimPackageSignatureMutation execution as type SignablePackage. */
  result?: Maybe<SignablePackage>;
};

/** Shared fields for benefit and deconversion reports */
export type ReportInterface = {
  /** The format of the report file (PDF, CSV, or ZIP) */
  contentType: BenefitReportContentType;
  /** The timestamp when the report was created */
  createdAt: Scalars['DateTime']['output'];
  /** The employer associated with the report */
  employer: Employer;
  /** The filename of the report */
  filename: Scalars['String']['output'];
  /** The unique identifier for the report */
  id: Scalars['ID']['output'];
  /** The name of the report */
  name: Scalars['String']['output'];
  /** The current status of the report (PENDING or COMPLETE) */
  status: BenefitReportStatus;
};

/** A list of documents that can be signed in-app via Docusign */
export type SignablePackage = {
  __typename: 'SignablePackage';
  /** DocuSign-related attributes required for signing the package. */
  docusignSignature?: Maybe<DocusignSignature>;
  /** The email address of the user whom the envelope was forwarded to for remote signing. */
  forwardedToEmail?: Maybe<Scalars['String']['output']>;
  /** The ID of the signable package. */
  id: Scalars['ID']['output'];
  /** The signature status of the signable package. */
  signed: Scalars['Boolean']['output'];
  /** The type of the signable package. */
  type: Scalars['String']['output'];
};

/** A support contact entry for an employer's 401(k) plan */
export type SupportContact = {
  __typename: 'SupportContact';
  /** Available hours description (e.g. 'Monday-Friday, 9:00am-6:00pm ET'), if applicable */
  availableHours?: Maybe<Scalars['String']['output']>;
  /** Calendly scheduling URL, present for client success managers and general plan support */
  calendlyUrl?: Maybe<Scalars['String']['output']>;
  /** Short description of what the support is for */
  description: Scalars['String']['output'];
  /** Contact email address */
  email?: Maybe<Scalars['String']['output']>;
  /** The name of the individual contact person, if applicable */
  name?: Maybe<Scalars['String']['output']>;
  /** Contact phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Display title for this contact row (e.g. 'Your advisor', 'Employee support') */
  title: Scalars['String']['output'];
};

/** Represents a collection of tasks for an employer. Currently only returns a count. */
export type TaskCollection = {
  __typename: 'TaskCollection';
  /** The number of tasks in the collection */
  count: Scalars['Int']['output'];
};

/** Autogenerated input type of UpdateEmployeeContributionRatesMutation */
export type UpdateEmployeeContributionRatesMutationInput = {
  /** The ID of the employee */
  employeeId: Scalars['ID']['input'];
  /** The ID of the employer */
  employerId: Scalars['ID']['input'];
  /** The payroll contribution rates for the Employee's legal accounts */
  legalAccountPayrollContributionRates: Array<LegalAccountPayrollContributionRatesInput>;
};

/** Autogenerated return type of UpdateEmployeeContributionRatesMutation. */
export type UpdateEmployeeContributionRatesMutationPayload = {
  __typename: 'UpdateEmployeeContributionRatesMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateEmployeeContributionRatesMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateEmployeeContributionRatesMutation execution as type Employee. */
  result?: Maybe<Employee>;
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "PayrollContributionRate": [
      "PayrollContributionAmount",
      "PayrollContributionPercent"
    ],
    "ReportInterface": [
      "BenefitReport",
      "DeconversionReport",
      "InvestmentActivityPackage"
    ]
  }
};
      export default result;
    


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  PayrollContributionRate:
    | ( PayrollContributionAmount )
    | ( PayrollContributionPercent )
  ;
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  ReportInterface:
    | ( Omit<BenefitReport, 'employer' | 'investmentActivityPackage'> & { employer: _RefType['Employer'], investmentActivityPackage?: Maybe<_RefType['InvestmentActivityPackage']> } )
    | ( Omit<DeconversionReport, 'employer'> & { employer: _RefType['Employer'] } )
    | ( Omit<InvestmentActivityPackage, 'employer'> & { employer: _RefType['Employer'] } )
  ;
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AuthorizationTier: AuthorizationTier;
  BenefitReport: ResolverTypeWrapper<Omit<BenefitReport, 'employer' | 'investmentActivityPackage'> & { employer: ResolversTypes['Employer'], investmentActivityPackage?: Maybe<ResolversTypes['InvestmentActivityPackage']> }>;
  BenefitReportContentType: BenefitReportContentType;
  BenefitReportCreationOption: ResolverTypeWrapper<BenefitReportCreationOption>;
  BenefitReportInputOption: ResolverTypeWrapper<BenefitReportInputOption>;
  BenefitReportInputOptionType: BenefitReportInputOptionType;
  BenefitReportStatus: BenefitReportStatus;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CapturePackageSignatureMutationInput: CapturePackageSignatureMutationInput;
  CapturePackageSignatureMutationPayload: ResolverTypeWrapper<CapturePackageSignatureMutationPayload>;
  Cents: ResolverTypeWrapper<Scalars['Cents']['output']>;
  CreateBenefitReportInput: CreateBenefitReportInput;
  CreateBenefitReportMutationInput: CreateBenefitReportMutationInput;
  CreateBenefitReportMutationPayload: ResolverTypeWrapper<Omit<CreateBenefitReportMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['BenefitReport']> }>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DeconversionReport: ResolverTypeWrapper<Omit<DeconversionReport, 'employer'> & { employer: ResolversTypes['Employer'] }>;
  DisplayableError: ResolverTypeWrapper<DisplayableError>;
  DocusignSignature: ResolverTypeWrapper<DocusignSignature>;
  EmailPreference: ResolverTypeWrapper<EmailPreference>;
  EmailPreferenceCategory: EmailPreferenceCategory;
  Employee: ResolverTypeWrapper<Omit<Employee, 'roth401kLegalAccount' | 'traditional401kLegalAccount'> & { roth401kLegalAccount?: Maybe<ResolversTypes['LegalAccount']>, traditional401kLegalAccount: ResolversTypes['LegalAccount'] }>;
  Employer: ResolverTypeWrapper<Omit<Employer, 'emailPreferences' | 'employee' | 'reports'> & { emailPreferences: Array<ResolversTypes['EmailPreference']>, employee: ResolversTypes['Employee'], reports: Array<ResolversTypes['ReportInterface']> }>;
  EmployerSupport: ResolverTypeWrapper<EmployerSupport>;
  FiveTwoNineBenefit: ResolverTypeWrapper<FiveTwoNineBenefit>;
  FiveTwoNineBenefitStatus: FiveTwoNineBenefitStatus;
  ForwardPackageSignatureMutationInput: ForwardPackageSignatureMutationInput;
  ForwardPackageSignatureMutationPayload: ResolverTypeWrapper<ForwardPackageSignatureMutationPayload>;
  HTML: ResolverTypeWrapper<Scalars['HTML']['output']>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InvestmentActivityPackage: ResolverTypeWrapper<Omit<InvestmentActivityPackage, 'employer'> & { employer: ResolversTypes['Employer'] }>;
  LegalAccount: ResolverTypeWrapper<Omit<LegalAccount, 'baseContributionRate' | 'bonusContributionRate'> & { baseContributionRate: ResolversTypes['PayrollContributionRate'], bonusContributionRate?: Maybe<ResolversTypes['PayrollContributionRate']> }>;
  LegalAccountPayrollContributionRatesInput: LegalAccountPayrollContributionRatesInput;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  Onboarding: ResolverTypeWrapper<Onboarding>;
  OnboardingStatus: OnboardingStatus;
  PayrollContributionAmount: ResolverTypeWrapper<PayrollContributionAmount>;
  PayrollContributionPercent: ResolverTypeWrapper<PayrollContributionPercent>;
  PayrollContributionRate: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PayrollContributionRate']>;
  PayrollContributionRateInput: PayrollContributionRateInput;
  Percent: ResolverTypeWrapper<Scalars['Percent']['output']>;
  PersonalProfile: ResolverTypeWrapper<PersonalProfile>;
  Plan: ResolverTypeWrapper<Plan>;
  PlanStatus: PlanStatus;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  ReclaimPackageSignatureMutationInput: ReclaimPackageSignatureMutationInput;
  ReclaimPackageSignatureMutationPayload: ResolverTypeWrapper<ReclaimPackageSignatureMutationPayload>;
  ReportInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ReportInterface']>;
  SignablePackage: ResolverTypeWrapper<SignablePackage>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SupportContact: ResolverTypeWrapper<SupportContact>;
  TaskCollection: ResolverTypeWrapper<TaskCollection>;
  UpdateEmployeeContributionRatesMutationInput: UpdateEmployeeContributionRatesMutationInput;
  UpdateEmployeeContributionRatesMutationPayload: ResolverTypeWrapper<Omit<UpdateEmployeeContributionRatesMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Employee']> }>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  BenefitReport: Omit<BenefitReport, 'employer' | 'investmentActivityPackage'> & { employer: ResolversParentTypes['Employer'], investmentActivityPackage?: Maybe<ResolversParentTypes['InvestmentActivityPackage']> };
  BenefitReportCreationOption: BenefitReportCreationOption;
  BenefitReportInputOption: BenefitReportInputOption;
  Boolean: Scalars['Boolean']['output'];
  CapturePackageSignatureMutationInput: CapturePackageSignatureMutationInput;
  CapturePackageSignatureMutationPayload: CapturePackageSignatureMutationPayload;
  Cents: Scalars['Cents']['output'];
  CreateBenefitReportInput: CreateBenefitReportInput;
  CreateBenefitReportMutationInput: CreateBenefitReportMutationInput;
  CreateBenefitReportMutationPayload: Omit<CreateBenefitReportMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['BenefitReport']> };
  Date: Scalars['Date']['output'];
  DateTime: Scalars['DateTime']['output'];
  DeconversionReport: Omit<DeconversionReport, 'employer'> & { employer: ResolversParentTypes['Employer'] };
  DisplayableError: DisplayableError;
  DocusignSignature: DocusignSignature;
  EmailPreference: EmailPreference;
  Employee: Omit<Employee, 'roth401kLegalAccount' | 'traditional401kLegalAccount'> & { roth401kLegalAccount?: Maybe<ResolversParentTypes['LegalAccount']>, traditional401kLegalAccount: ResolversParentTypes['LegalAccount'] };
  Employer: Omit<Employer, 'emailPreferences' | 'employee' | 'reports'> & { emailPreferences: Array<ResolversParentTypes['EmailPreference']>, employee: ResolversParentTypes['Employee'], reports: Array<ResolversParentTypes['ReportInterface']> };
  EmployerSupport: EmployerSupport;
  FiveTwoNineBenefit: FiveTwoNineBenefit;
  ForwardPackageSignatureMutationInput: ForwardPackageSignatureMutationInput;
  ForwardPackageSignatureMutationPayload: ForwardPackageSignatureMutationPayload;
  HTML: Scalars['HTML']['output'];
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  InvestmentActivityPackage: Omit<InvestmentActivityPackage, 'employer'> & { employer: ResolversParentTypes['Employer'] };
  LegalAccount: Omit<LegalAccount, 'baseContributionRate' | 'bonusContributionRate'> & { baseContributionRate: ResolversParentTypes['PayrollContributionRate'], bonusContributionRate?: Maybe<ResolversParentTypes['PayrollContributionRate']> };
  LegalAccountPayrollContributionRatesInput: LegalAccountPayrollContributionRatesInput;
  Mutation: Record<PropertyKey, never>;
  Onboarding: Onboarding;
  PayrollContributionAmount: PayrollContributionAmount;
  PayrollContributionPercent: PayrollContributionPercent;
  PayrollContributionRate: ResolversUnionTypes<ResolversParentTypes>['PayrollContributionRate'];
  PayrollContributionRateInput: PayrollContributionRateInput;
  Percent: Scalars['Percent']['output'];
  PersonalProfile: PersonalProfile;
  Plan: Plan;
  Query: Record<PropertyKey, never>;
  ReclaimPackageSignatureMutationInput: ReclaimPackageSignatureMutationInput;
  ReclaimPackageSignatureMutationPayload: ReclaimPackageSignatureMutationPayload;
  ReportInterface: ResolversInterfaceTypes<ResolversParentTypes>['ReportInterface'];
  SignablePackage: SignablePackage;
  String: Scalars['String']['output'];
  SupportContact: SupportContact;
  TaskCollection: TaskCollection;
  UpdateEmployeeContributionRatesMutationInput: UpdateEmployeeContributionRatesMutationInput;
  UpdateEmployeeContributionRatesMutationPayload: Omit<UpdateEmployeeContributionRatesMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Employee']> };
};

export type OwnedDirectiveArgs = {
  by: Scalars['String']['input'];
};

export type OwnedDirectiveResolver<Result, Parent, ContextType = any, Args = OwnedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type BenefitReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitReport'] = ResolversParentTypes['BenefitReport']> = {
  contentType?: Resolver<ResolversTypes['BenefitReportContentType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentActivityPackage?: Resolver<Maybe<ResolversTypes['InvestmentActivityPackage']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BenefitReportStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BenefitReportCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitReportCreationOption'] = ResolversParentTypes['BenefitReportCreationOption']> = {
  additionalGuidance?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  altIdentifier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  columns?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputs?: Resolver<Array<ResolversTypes['BenefitReportInputOption']>, ParentType, ContextType>;
  isCommon?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BenefitReportInputOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitReportInputOption'] = ResolversParentTypes['BenefitReportInputOption']> = {
  attribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  default?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BenefitReportInputOptionType'], ParentType, ContextType>;
};

export type CapturePackageSignatureMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CapturePackageSignatureMutationPayload'] = ResolversParentTypes['CapturePackageSignatureMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SignablePackage']>, ParentType, ContextType>;
};

export interface CentsScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Cents'], any> {
  name: 'Cents';
}

export type CreateBenefitReportMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateBenefitReportMutationPayload'] = ResolversParentTypes['CreateBenefitReportMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['BenefitReport']>, ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeconversionReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeconversionReport'] = ResolversParentTypes['DeconversionReport']> = {
  contentType?: Resolver<ResolversTypes['BenefitReportContentType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  liquidationDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BenefitReportStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisplayableErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayableError'] = ResolversParentTypes['DisplayableError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DocusignSignatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocusignSignature'] = ResolversParentTypes['DocusignSignature']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signatureUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EmailPreferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailPreference'] = ResolversParentTypes['EmailPreference']> = {
  category?: Resolver<ResolversTypes['EmailPreferenceCategory'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type EmployeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Employee'] = ResolversParentTypes['Employee']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  roth401kLegalAccount?: Resolver<Maybe<ResolversTypes['LegalAccount']>, ParentType, ContextType>;
  traditional401kLegalAccount?: Resolver<ResolversTypes['LegalAccount'], ParentType, ContextType>;
};

export type EmployerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Employer'] = ResolversParentTypes['Employer']> = {
  emailPreferences?: Resolver<Array<ResolversTypes['EmailPreference']>, ParentType, ContextType>;
  employee?: Resolver<ResolversTypes['Employee'], ParentType, ContextType, RequireFields<EmployerEmployeeArgs, 'id'>>;
  fiveTwoNineBenefit?: Resolver<Maybe<ResolversTypes['FiveTwoNineBenefit']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onboarding?: Resolver<Maybe<ResolversTypes['Onboarding']>, ParentType, ContextType>;
  plan?: Resolver<Maybe<ResolversTypes['Plan']>, ParentType, ContextType>;
  reportCreationOptions?: Resolver<Array<ResolversTypes['BenefitReportCreationOption']>, ParentType, ContextType>;
  reportableYears?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  reports?: Resolver<Array<ResolversTypes['ReportInterface']>, ParentType, ContextType>;
  support?: Resolver<ResolversTypes['EmployerSupport'], ParentType, ContextType>;
  tasks?: Resolver<ResolversTypes['TaskCollection'], ParentType, ContextType>;
};

export type EmployerSupportResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployerSupport'] = ResolversParentTypes['EmployerSupport']> = {
  contacts?: Resolver<Array<ResolversTypes['SupportContact']>, ParentType, ContextType>;
};

export type FiveTwoNineBenefitResolvers<ContextType = any, ParentType extends ResolversParentTypes['FiveTwoNineBenefit'] = ResolversParentTypes['FiveTwoNineBenefit']> = {
  status?: Resolver<ResolversTypes['FiveTwoNineBenefitStatus'], ParentType, ContextType>;
};

export type ForwardPackageSignatureMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ForwardPackageSignatureMutationPayload'] = ResolversParentTypes['ForwardPackageSignatureMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SignablePackage']>, ParentType, ContextType>;
};

export interface HtmlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['HTML'], any> {
  name: 'HTML';
}

export type InvestmentActivityPackageResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvestmentActivityPackage'] = ResolversParentTypes['InvestmentActivityPackage']> = {
  contentType?: Resolver<ResolversTypes['BenefitReportContentType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType>;
  endDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  filename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  level?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BenefitReportStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LegalAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalAccount'] = ResolversParentTypes['LegalAccount']> = {
  baseContributionRate?: Resolver<ResolversTypes['PayrollContributionRate'], ParentType, ContextType>;
  bonusContributionRate?: Resolver<Maybe<ResolversTypes['PayrollContributionRate']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  capturePackageSignature?: Resolver<ResolversTypes['CapturePackageSignatureMutationPayload'], ParentType, ContextType, RequireFields<MutationCapturePackageSignatureArgs, 'input'>>;
  createBenefitReport?: Resolver<ResolversTypes['CreateBenefitReportMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateBenefitReportArgs, 'input'>>;
  forwardPackageSignature?: Resolver<ResolversTypes['ForwardPackageSignatureMutationPayload'], ParentType, ContextType, RequireFields<MutationForwardPackageSignatureArgs, 'input'>>;
  reclaimPackageSignature?: Resolver<ResolversTypes['ReclaimPackageSignatureMutationPayload'], ParentType, ContextType, RequireFields<MutationReclaimPackageSignatureArgs, 'input'>>;
  updateEmployeeContributionRates?: Resolver<ResolversTypes['UpdateEmployeeContributionRatesMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateEmployeeContributionRatesArgs, 'input'>>;
};

export type OnboardingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Onboarding'] = ResolversParentTypes['Onboarding']> = {
  status?: Resolver<ResolversTypes['OnboardingStatus'], ParentType, ContextType>;
};

export type PayrollContributionAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionAmount'] = ResolversParentTypes['PayrollContributionAmount']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayrollContributionPercentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionPercent'] = ResolversParentTypes['PayrollContributionPercent']> = {
  percent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayrollContributionRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionRate'] = ResolversParentTypes['PayrollContributionRate']> = {
  __resolveType: TypeResolveFn<'PayrollContributionAmount' | 'PayrollContributionPercent', ParentType, ContextType>;
};

export interface PercentScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Percent'], any> {
  name: 'Percent';
}

export type PersonalProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonalProfile'] = ResolversParentTypes['PersonalProfile']> = {
  authorizationTier?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isAdvisor?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  jobTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  middleInitial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workPhoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['Plan'] = ResolversParentTypes['Plan']> = {
  status?: Resolver<ResolversTypes['PlanStatus'], ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType, RequireFields<QueryEmployerArgs, 'id'>>;
  employers?: Resolver<Array<ResolversTypes['Employer']>, ParentType, ContextType>;
  personalProfile?: Resolver<ResolversTypes['PersonalProfile'], ParentType, ContextType, RequireFields<QueryPersonalProfileArgs, 'employerId'>>;
  signablePackage?: Resolver<ResolversTypes['SignablePackage'], ParentType, ContextType, RequireFields<QuerySignablePackageArgs, 'id'>>;
};

export type ReclaimPackageSignatureMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReclaimPackageSignatureMutationPayload'] = ResolversParentTypes['ReclaimPackageSignatureMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SignablePackage']>, ParentType, ContextType>;
};

export type ReportInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportInterface'] = ResolversParentTypes['ReportInterface']> = {
  __resolveType: TypeResolveFn<'BenefitReport' | 'DeconversionReport' | 'InvestmentActivityPackage', ParentType, ContextType>;
};

export type SignablePackageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignablePackage'] = ResolversParentTypes['SignablePackage']> = {
  docusignSignature?: Resolver<Maybe<ResolversTypes['DocusignSignature']>, ParentType, ContextType>;
  forwardedToEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  signed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SupportContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportContact'] = ResolversParentTypes['SupportContact']> = {
  availableHours?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  calendlyUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type TaskCollectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaskCollection'] = ResolversParentTypes['TaskCollection']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type UpdateEmployeeContributionRatesMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateEmployeeContributionRatesMutationPayload'] = ResolversParentTypes['UpdateEmployeeContributionRatesMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Employee']>, ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  BenefitReport?: BenefitReportResolvers<ContextType>;
  BenefitReportCreationOption?: BenefitReportCreationOptionResolvers<ContextType>;
  BenefitReportInputOption?: BenefitReportInputOptionResolvers<ContextType>;
  CapturePackageSignatureMutationPayload?: CapturePackageSignatureMutationPayloadResolvers<ContextType>;
  Cents?: GraphQLScalarType;
  CreateBenefitReportMutationPayload?: CreateBenefitReportMutationPayloadResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  DeconversionReport?: DeconversionReportResolvers<ContextType>;
  DisplayableError?: DisplayableErrorResolvers<ContextType>;
  DocusignSignature?: DocusignSignatureResolvers<ContextType>;
  EmailPreference?: EmailPreferenceResolvers<ContextType>;
  Employee?: EmployeeResolvers<ContextType>;
  Employer?: EmployerResolvers<ContextType>;
  EmployerSupport?: EmployerSupportResolvers<ContextType>;
  FiveTwoNineBenefit?: FiveTwoNineBenefitResolvers<ContextType>;
  ForwardPackageSignatureMutationPayload?: ForwardPackageSignatureMutationPayloadResolvers<ContextType>;
  HTML?: GraphQLScalarType;
  InvestmentActivityPackage?: InvestmentActivityPackageResolvers<ContextType>;
  LegalAccount?: LegalAccountResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Onboarding?: OnboardingResolvers<ContextType>;
  PayrollContributionAmount?: PayrollContributionAmountResolvers<ContextType>;
  PayrollContributionPercent?: PayrollContributionPercentResolvers<ContextType>;
  PayrollContributionRate?: PayrollContributionRateResolvers<ContextType>;
  Percent?: GraphQLScalarType;
  PersonalProfile?: PersonalProfileResolvers<ContextType>;
  Plan?: PlanResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ReclaimPackageSignatureMutationPayload?: ReclaimPackageSignatureMutationPayloadResolvers<ContextType>;
  ReportInterface?: ReportInterfaceResolvers<ContextType>;
  SignablePackage?: SignablePackageResolvers<ContextType>;
  SupportContact?: SupportContactResolvers<ContextType>;
  TaskCollection?: TaskCollectionResolvers<ContextType>;
  UpdateEmployeeContributionRatesMutationPayload?: UpdateEmployeeContributionRatesMutationPayloadResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  owned?: OwnedDirectiveResolver<any, any, ContextType>;
};
